import React from 'react'
import FontIcon from '@material-ui/core/Icon'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Popover from '@material-ui/core/Popover'

import { Button, Icon as ChromeIcon } from 'src/chrome'
import { getCondensedTotal, onlyHasGift, recipientCount } from 'src/helpers'
import { OrderWithPartialLines } from 'src/redux/reducers/orders'
import { useActions, useSelector, useState } from 'src/hooks'

import styles from './orderHeader.module.scss'
import { ListItemText } from '@material-ui/core'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import { Div, Text } from '@sendoutcards/quantum-design-ui'

interface OrderHeaderProps {
  order: OrderWithPartialLines
}

const OrderHeader: React.FC<OrderHeaderProps> = props => {
  const { order } = props
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
  const actions = useActions()
  const { isMobile } = useSelector(state => state.window)
  const addressCount = recipientCount(order)

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    setAnchorEl(event.currentTarget)

  const handleClose = () => setAnchorEl(null)

  const isOpen = Boolean(anchorEl)
  const campaign = order.campaign

  return (
    <header className={styles.orderHeader}>
      {!isMobile && (
        <Div
          style={{
            position: 'absolute',
            width: '100%',
          }}
        >
          <Text
            type="title"
            color="primaryHeading"
            weight="bold"
            lineHeight={1.5}
            alignment="center"
          >
            Order Checkout
          </Text>
        </Div>
      )}
      <Div
        className={styles.orderInfo}
        style={{
          justifyContent: 'space-between',
          width: '100%',
          margin: '0 25px 0 25px',
        }}
      >
        {isMobile && (
          <Div>
            <Text type="subtitle">Order Checkout</Text>
            <Text type="footnote">Add a Return Address and Recipient</Text>
          </Div>
        )}
        <Div>
          {campaign && (
            <Button
              id={'view_parent_campaign_btn'}
              title="View parent campaign"
              buttonColor={'pink'}
              className={styles.campaignButton}
              disabled={!order}
              onClick={() => actions.openCampaign(campaign.id)}
            />
          )}
        </Div>
        <Div display="flex" id="order-header">
          {order.warnings.length > 0 && (
            <div className={styles.orderWarnings} onClick={handleClick}>
              <ChromeIcon icon={'BELL'} />
              <span className={styles.badge}>
                <Text
                  type="body"
                  color="accent"
                  weight="bold"
                  lineHeight={1.5}
                  alignment="center"
                >
                  {order.warnings.length}
                </Text>
              </span>
            </div>
          )}
          <Div
            className={styles.addressCount}
            onClick={() => actions.openAddressDrawer()}
          >
            <ChromeIcon icon={'USER'} viewBox={'0 0 32 32'} />
            <span className={styles.badge}>
              <Text
                type="body"
                color="accent"
                weight="bold"
                lineHeight={1}
                alignment="center"
              >
                {addressCount}
              </Text>
            </span>
          </Div>
          <Div className={styles.orderTotal}>
            <ChromeIcon icon={'BAG'} />
            {addressCount > 0 && !onlyHasGift(order) && (
              <Text type="body" outset={{ left: 'x1' }}>
                {getCondensedTotal(order.cost)}
              </Text>
            )}
          </Div>
        </Div>
      </Div>
      <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        style={{ right: 0, color: '#ff5689' }}
        className={styles.popover}
      >
        <List>
          {order.warnings.map((warning, index) => {
            return (
              <ListItem key={index}>
                <ListItemIcon>
                  <FontIcon
                    style={{ color: '#DD2476' }}
                    className="material-icons"
                  >
                    error
                  </FontIcon>
                </ListItemIcon>
                <ListItemText
                  primary={<Text type="caption">{warning.message}</Text>}
                  disableTypography={true}
                />
              </ListItem>
            )
          })}
        </List>
      </Popover>
    </header>
  )
}

export default OrderHeader
